<script setup lang="ts">
// Enable automatic query invalidation when context changes for all pages
useContextRefresh()
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <Toolbar />
    <main class="flex-grow flex flex-col">
      <slot />
    </main>
    <Footer />
  </div>
</template>
